import { useLocation, useSearchParams, Link, useLoaderData, Outlet } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import ServerFooter from "../common/ServerFooter";
import { Organization } from "./types";
export const extraFields = ["page", "limit", "typeOfWork", "orderBy"];
//--------------------------------------------------------------------------------------------
export default function OrganizationList(){
    const [searchParams, setSearchParams] = useSearchParams();
    const categoryOfWork = searchParams.get("typeOfWork") ?? "";
    const { organizations, total, procsByCategory }:{ organizations: Organization[], total: number, procsByCategory:  Record<string, string[]> } = useLoaderData();
    const location = useLocation();
    const onFilter = [...searchParams.keys()].filter(param => !extraFields.includes(param)).length > 0;

    const orderBy = searchParams.get("orderBy") ?? "";
    const nameOrderSymbol = orderBy === "nameASC" ? "↑" : orderBy === "nameDESC" ? "↓" : "⇅";
    const numberOfJobsPerformedOrderSymbol = orderBy === "numberOfJobsPerformedASC" ? "↑" : orderBy === "numberOfJobsPerformedDESC" ? "↓" : "⇅";
    const lastJobPerformedOrderSymbol = orderBy === "lastJobPerformedASC" ? "↑" : orderBy === "lastJobPerformedDESC" ? "↓" : "⇅";
    //--------------------------------------------------------------------------------------------
    return(
        <div className = {"cssContent" + (total > 0?" pb8rem":"")}>
            <div className = "mt-2">
                <Link className = {"btn btn-outline-primary pointer position-relative"} to = {{ pathname: "Filter", search: location.search }} replace>
                    Filter
                   {onFilter?<span children = "on" className = "badge text-bg-primary position-absolute top-0 start-100 translate-middle" style = {{minWidth: "2.4em"}}/>:null}
                </Link>
                <Link children = "Export" className = "btn btn-outline-primary pointer ms-3" to = {{ pathname: "Export", search: location.search }}/>
                <label children = "Type of Work" htmlFor = "typeOfWork" className = "ms-3"/>
                <select
                    className = "form-select inline ms-2"
                    value = {categoryOfWork}
                    onChange = {e => {
                        const value = e.currentTarget.value;
                        const params = new URLSearchParams(searchParams);
                        if(value) params.set("typeOfWork", value);
                        else params.delete("typeOfWork");
                        setSearchParams(params, { replace: false });
                    }}
                >
                    <option value = "">All</option>
                    {Object.entries(procsByCategory).map(([key, value]) => <optgroup key = {key} label = {key} children = {value.map(item => <option value = {item} label = {item}/>)}/>)}
                </select>
                <Link children = "Add" className = "btn btn-outline-primary float-end" to = "Add"/>
            </div>
            {!organizations.length?<div className = "cssLoading">Empty</div>:
            <div className = "table-responsive">
                <table className = "table">
                    <thead className = "noTableTopBorder">
                        <tr>
                            <th>
                                <button
                                    children = "Organization Name"
                                    type = "button"
                                    className = "noButtonStyle pointer"
                                    onClick = {() => {
                                        const params = new URLSearchParams(searchParams);
                                        switch(orderBy){
                                            case "nameASC":
                                                params.set("orderBy", "nameDESC");
                                                break;
                                            case "nameDESC":
                                                params.delete("orderBy");
                                                break;
                                            default:
                                                params.set("orderBy", "nameASC");
                                                break;
                                        }
                                        setSearchParams(params, { replace: false });
                                    }}
                                />
                                <strong className = "text-danger" children = {nameOrderSymbol}/>
                            </th>
                            <th>Website</th>
                            <th>Business Phone</th>
                            <th>Fax</th>
                            <th>
                                <button
                                    children = "Number of Job Performed"
                                    type = "button"
                                    className = "noButtonStyle pointer"
                                    onClick = {() => {
                                        const params = new URLSearchParams(searchParams);
                                        switch(orderBy){
                                            case "numberOfJobsPerformedASC":
                                                params.set("orderBy", "numberOfJobsPerformedDESC");
                                                break;
                                            case "numberOfJobsPerformedDESC":
                                                params.delete("orderBy");
                                                break;
                                            default:
                                                params.set("orderBy", "numberOfJobsPerformedASC");
                                                break;
                                        }
                                        setSearchParams(params, { replace: false });
                                    }}
                                />
                                <strong className = "text-danger" children = {numberOfJobsPerformedOrderSymbol}/>
                            </th>
                            <th>
                                <button
                                    children = "Last Job Performed"
                                    type = "button"
                                    className = "noButtonStyle pointer"
                                    onClick = {() => {
                                        const params = new URLSearchParams(searchParams);
                                        switch(orderBy){
                                            case "lastJobPerformedASC":
                                                params.set("orderBy", "lastJobPerformedDESC");
                                                break;
                                            case "lastJobPerformedDESC":
                                                params.delete("orderBy");
                                                break;
                                            default:
                                                params.set("orderBy", "lastJobPerformedASC");
                                                break;
                                        }
                                        setSearchParams(params, { replace: false });
                                    }}
                                />
                                <strong className = "text-danger" children = {lastJobPerformedOrderSymbol}/>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {organizations.map((org, key) => 
                        <tr key = {key}>
                            <td>{org.name}</td>
                            <td>{org.website?<a href = {org.website} target = "_blank" rel = "noreferrer">{org.website}</a>:<></>}</td>
                            <td>{org.phoneNumber?<a href = {`tel:+1${org.phoneNumber.replace(/-/g, "")}${org.extension?`,${org.extension}`:""}`}>{org.phoneNumber}{org.extension?` Ext. ${org.extension}`:null}</a>:<></>}</td>
                            <td>{org.fax?<a href = {"fax:+1" + org.fax.replace(/-/g, "")}>{org.fax}</a>:<></>}</td>
                            <td>{org.numberOfJobsPerformed || ""}</td>
                            <td>{org.lastJobPerformed}</td>
                            <td><Link children = "Detail" className = "btn btn-outline-primary" to = {String(org.id)}/></td>
                        </tr>)}
                    </tbody>
                </table>
            </div>}
            {total > 0? <ServerFooter length = {total}/> : null}
            <Outlet/>
        </div>
    )
}